define('views/modules/calendar/calendar/calendar-component/item/calendar-day-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    'services/i18n', 'services/user',
    // services
    'services/events/calendar-events',
    'services/events/animated-session-events',
    'services/toastr-service',
    'services/app-state',
    'services/platform.service',
    // models
    'models/calendar/session',
    // Views
    'views/parts/menu/menu-context',
    'views/modules/calendar/calendar/calendar-component/item/item-delete-modal',
    // Templates
    'text!templates/modules/calendar/calendar/calendar-component/item/calendar-day-item.html'
], function(
    // libs
    _, Backbone, Mustache, moment, Bootbox, U,
    i18n, User,
    // services
    CalendarEvents,
    AnimationEvents,
    ToastrService,
    AppState,
    PlatformService,
    // models
    MSession,
    // views
    VMenuContext,
    VCalendarItemDeleteModal,
    // templates
    TCalendarDayItem
) {

    var VCalendarDayItem = Backbone.View.extend({
        tagName: "li",
        className: "calendar-item",
        template: TCalendarDayItem,

        events: {
            "click": "onClick",
            "click .option-menu-toggle": "showMenuOptions",
            "click .item-check": "onDoneCheck",
            "item:move": "onMove",
            "click .clickable-link": "openUrl"
        },

        regions: {
            check: ".item-check",
            menu: ".menu-options",
            toggle: ".option-menu-toggle",
            title: ".item-title"
        },

        initialize: function(opt) {
            opt = this.options = _.extend({
                summary: true,
                duplicate: true
            }, opt);

            this.setUrl("parent", opt.url);
            this.updateUrl();

            this.view = {};

            this.listenTo(this.model, {
                // displayName is for nutrition because name can't be used with the base item model
                "change:name change:date change:value change:displayName": this.render,
                "change:done": this.onDoneChange,
                "change:feedback_level": this.onFeedbackLevelChange,
                "remove": this.remove,
            });

            this.listenTo(Backbone.history, "route", this.onRoute);

        },

        render: function() {
            this.initListener();
            var model = this.model;

            var html = Mustache.render(this.template, Mustache.getContext({
                feedback: true,
                url: this.url.root,
                title: model.getDisplayTitle(),
                type: model.get('type'),
                date: model.getDate().format("YYYY/MM/DD"),
                description: model.get('type') === "activity" ? model.getTruncatedDescription() : model.getDescription(),
                isGarmin: Boolean(model.get('garmin_summary_id')),
                summary: this.options.summary,
                weekNumber: this.getWeekNumber()
            }));

            this.$el.empty().append(html);

            this.generateZones()
                .setDone(model.get('done'))
                .setFeedbackLevel(model.get('feedback_level'))
                .setActive()
                .addFilterClass()
                .setDoneTooltip(model.get('done'));

            if (! User.canHideItems() || model.get('owner') === "") {
                return this;
            }

            if (model.isAfterDays(User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden)) {
                if (AppState.onSupervisorSide()) {
                    if (model.get('isVisible')) {
                        return this;
                    }
                    this.applyHiddenStyles(this.$el);
                    return this;
                }

                if (this.isCalendarItemInvisible(model)) {
                    this.$el.hide();
                }
            }

            return this;
        },

        getWeekNumber: function() {
            if (this.model.get('type') !== "animated") {
                return null;
            }
            return parseInt(this.model.get('week')) + 1;
        },

        isCalendarItemInvisible: function(model) {
            return ! _.isUndefined(model.get('owner')) && model.get('owner') !== User.getCurrentlySelectedUser().id && ! model.get('isVisible');
        },

        applyHiddenStyles: function(el) {
            el.find('.item-content').css('opacity', 0.5);
            el.find('.item-type').append(" (" + i18n.t('hidden').toLowerCase() + ")");
        },

        clientHasCreatedAndCanSeeItem: function(model) {
            return model.get('owner') === User.getCurrentlySelectedUser().id && model.get('isVisible');
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'toggle:done': this.onToggleDone,
                'onItemWeekChange': this.onItemWeekChange
            });
            return this;
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            this.createContextMenu();
        },

        createContextMenu: function() {
            var menuItems = new Backbone.Collection([
                { caption: "calendar:Feedback", icon: "sl-icon-energy", route: this.url.feedback },
                { caption: "Edit", icon: "sl-icon-pencil", route: this.isAnimatedSession() ? this.url.session : this.url.root },
                { caption: "Delete", icon: "sl-icon-trash", callback: this.onDeleteAction },
            ]);

            if (this.model.get('type') === 'animated' && !User.get('_canViewAnimatedSessions') && AppState.onClientSide()) {
                menuItems.remove(menuItems.at(1));
            }

            if (this.options.duplicate && ! this.goalsPageIsActive()) {
                menuItems.add({ caption: "Duplicate", icon: "sl-icon-docs", callback: this.onDuplicateAction });
            }

            if (this.isAnimatedSession()) {
                menuItems.add({ caption: "calendar:Download", icon: "sl-icon-printer", callback: this.onPrintAction });
            }

            if (! this.goalsPageIsActive()) {
                menuItems.add(
                    { caption: "calendar:move", icon: "sl-icon-cursor-move", callback: this.onMoveModalAction },
                );
            }

            if (User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden && this.model.isAfterDays(User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden) && ! AppState.onClientSide()) {
                if (this.model.get('isVisible')) {
                    menuItems.add({ caption: "calendar:hide", icon: "fa fa-eye-slash", callback: this.onToggleVisibleAction });
                } else {
                    menuItems.add({ caption: "calendar:unhide", icon: "fa fa-eye", callback: this.onToggleVisibleAction });
                }
            }

            this.vMenuOptions = new VMenuContext({
                context: this,
                onClick: this.onActionClick,
                collection: menuItems
            });

            this.assign(this.vMenuOptions, this.zone.$menu);

            this.vMenuOptions.toggle();
        },

        goalsPageIsActive: function() {
            return Backbone.history.getFragment().indexOf('goals') !== -1 || Backbone.history.getFragment().indexOf('goal') !== -1;
        },

        updateUrl: function() {
            var model = this.model,
                dayId = moment(model.get('date')).format("YYYY-MM-DD"),
                type = model.getType();

            this.setUrl("root", Mustache.render("{{{root}}}{{{dayId}}}/{{{type}}}/{{{id}}}/{{#itemId}}item/{{itemId}}/{{/itemId}}", {
                root: this.url.parent,
                dayId: dayId,
                type: type,
                id: this.getId(),
                itemId: this.isAnimatedSession() ? model.id : false,
            }));

            if (this.isAnimatedSession()) {
                this.setUrl("session", Mustache.render("{{{root}}}{{{dayId}}}/{{{type}}}/{{{id}}}", {
                    root: this.url.parent,
                    dayId: dayId,
                    type: this.model.get('type'),
                    id: this.getId(),
                }));
            }

            this.setUrl("feedback", this.url.root + "feedback");
        },

        setTitle: function(val) {
            this.zone.$title.html(val);
            return this;
        },

        isDone: function() {
            return this.$el.hasClass("completed");
        },

        setDone: function(val) {
            this.$el.toggleClass("completed", val);
            return this;
        },

        setFeedbackLevel: function(val) {
            this.$el.removeClassPrefix('level-');
            this.$el.addClass("level-" + val);
            return this;
        },

        setActive: function(val) {
            if (_.isUndefined(val)) {
                val = this.model.isReferencedInUrl();
            }
            this.$el.toggleClass("active", val);
            return this;
        },

        setDoneTooltip: function(activityDone) {
            if (activityDone) {
              this.$el.attr("title", i18n.t("calendar:This activity has been marked as Done"));
            } else {
              this.$el.removeAttr("title");
            }
            return this;
        },


        getId: function() {
            var id = this.model.id;
            if (this.model.get('type') === "animated") {
                id = this.model.get('session');
            }
            return id;
        },

        isAnimatedSession: function() {
            return this.model.get('type') === "animated";
        },

        isCustomData: function() {
            return this.model.get('type') === "custom_data";
        },

        closeDetails: function() {
            // toggle back to the calendar
            if (this.model.isReferencedInUrl()) {
                Backbone.history.redirect(this.url.parent);
                return true;
            }
            return false;
        },

        addFilterClass: function() {
            this.$el.addClass(this.model.getFilterClass());
            return this;
        },

        toggleSessionExercisesDone: function() {
            var session = this.session,
                done = this.model.isDone(),
                exercises = session.getExerciseCollection();

            exercises.each(function(model) {
                model.setWeekDone(this.model.getWeek(), done);
            }, this);

            session.setExercises(exercises.toJSON({ blacklist: true }));

            session.save(session.changedAttributes(), {
                patch: true,
                context: this,
                success: function() {
                    AnimationEvents.sessionItemDone(session, this.model, done);
                }
            });
        },

        fetchRelatedSession: function() {
            var model = this.model,
                session = new MSession();

            session.setId(model.get('session'))
                .fetch({
                    context: this,
                    success: this.onSessionSync
                });
        },

        performClick: function(e) {
            var target = e.target,
                zone = this.zone;
            if (target === zone.$toggle.get(0) ||
                target === zone.$check.get(0) || this.closeDetails()
            ) {
                e.preventDefault();
            }
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.stopPropagation();
        },

        onEditAction: function() {
            U.log(this.url);
            if (this.isAnimatedSession()) {

            } else {

            }
        },

        onDuplicateAction: function(e) {
            e.preventDefault();
            this.model.trigger("item:duplicate", this.model);
        },

        onMoveModalAction: function(e) {
            e.preventDefault();
            this.model.trigger("item:move:modal", this.model);
        },

        onPrintAction: function(e) {
            this.model.trigger("item:print", this.model);
            e.preventDefault();
        },

        onDeleteAction: function(e) {
            e.preventDefault();
            // TODO add a button for "all" the items of a session.
            // Bootbox.confirm({
            //     title: i18n.t('Delete an activity'),
            //     message: i18n.t('messages:message-delete-activity'),
            //     callback: this.onDelete,
            //     context: this,
            // });
            var view = this.view,
                modal = view.destroy || (view.destroy = new VCalendarItemDeleteModal());

            modal.setModel(this.model).render();
        },

        ////////////
        // events //
        ////////////

        onSessionSync: function(model, options) {
            this.session = model;
            this.toggleSessionExercisesDone();
        },

        onClick: function(e) {
            if (PlatformService.isNative()) {
                e.preventDefault();
                Backbone.history.navigate(this.url.root);
            } else {
                _.debounce(this.performClick.bind(this, e), 500, true);
            }
        },

        onMove: function(e, data) {
            var model = this.model;
            model.trigger("item:remove", model);
            data.collection.add(model, { at: data.position, silent: true, sync: false });
            var attrs = model.changedAttributes();
            attrs = _.extend({}, model.changedAttributes(), attrs);

            if (model.isInFuture()) {
                attrs.done = false;
            }

            var options = { patch: true, context: this };

            if (this.model.get('type') === "animated") {
                options.autofixRelated = true;
            }

            // if (attrs) {
            model.save(attrs, options)
                .always(function() {
                    this.onDateChange(model, model.get('date'));
                    if (model.isReferencedInUrl()) {
                        Backbone.history.redirect(this.url.root);
                    }
                });
            // }
            this.vMenuOptions = null;
            CalendarEvents.itemMove(model);
        },

        onDoneCheck: function(e) {
            var model = this.model;
            if (!model.hasPassed()) {
                ToastrService.error('calendar:cannot-mark-future-items-as-done');
                return;
            }

            model.save({ done: !model.get('done') }, {
                patch: true,
                context: this,
                success: function() {
                    CalendarEvents.toggleDone(model, model.get('done'));
                    if (this.isAnimatedSession()) {
                        this.fetchRelatedSession();
                    }
                    if (model.isDone()) {
                        model.trigger('show:feedback', model.clone());
                    }
                    this.setDoneTooltip(model.get('done'));
                }
            });
        },

        onDateChange: function(model, value, options) {
            var oldDone = model.isDone();
            this.updateUrl();

            model.toggleDone(model.isInFuture() ? false : oldDone);

            if (!oldDone && model.isDone()) {
                model.trigger('show:feedback', model.clone());
            }
            this.render();
        },

        onDoneChange: function(model, value, options) {
            this.setDone(value);
        },

        onFeedbackLevelChange: function(model, value, options) {
            this.setFeedbackLevel(value);
        },

        onRoute: function(router, route, params) {
            this.setActive();
        },

        onDelete: function(result) {
            if (result) {
                this.closeDetails();
                this.model.destroy();
            }
        },

        onToggleDone: function(model, value) {
            if (model.is(this.model) && value !== this.isDone()) {
                this.model.set('done', value);
            }
        },

        onDisable: function() {
          this.stopListeningTo(CalendarEvents);
        },

        openUrl: function(event) {
          var url = event.target.getAttribute('data-url');
          window.open(url, '_blank');
        },

        onToggleVisibleAction: function() {
            this.model.save({ date: this.model.get('date'), isVisible: !this.model.get('isVisible') }, { patch: true });

            this.render();
        },

        onItemWeekChange: function(session) {
            if (session === this.model.get('session')) {
                this.when(this.model.fetch({ force: true }))
                    .then(this.render.bind(this));
            }
        }

    });

    return VCalendarDayItem;
});

